import styled from "styled-components";

export const TableDiv = styled.div`
    overflow-x: auto;
    background-color: #ffffff;
`

const Table: any = styled.table`
    border: 1px solid #000;
    border-collapse: collapse;
`

Table.TheadCell = styled.td.attrs(({colSpan}) => ({
    colSpan: colSpan || 0
}))`
    border: 1px solid #000;
    text-align: center;
    font-size: 0.950rem;
    font-weight: bold;
`

Table.Trow = styled.tr`

`

Table.TrowCell= styled.td`
    border: 1px solid #000;
    text-align: center;
`

export default Table